<apc-multi-forms [forms]="forms" (addTitleToCollapsableEvent)="addTitleToCollapsable(forms)"
    [newEmptyForm]="initNewForm" [newDataForm]="initForm" [getData]="productsService.getProducts"
    [createData]="productsService.createProduct" [updateData]="productsService.updateProduct"
    [deleteData]="productsService.deleteProduct" [user_id]="user_id" [formTemplate]="formTmpl" pertinence="subsection"
    section="product" subsection="product" icon="assets/ico/user-solid.svg"
    header="{{'order.product.title' | translate | titlecase}}" [openedId]="openedId">
</apc-multi-forms>

<ng-template #formTmpl let-data>
    <form [formGroup]="data">
        <div class="container-fluid">
            <div class="row mb-3">
                <div class="form-group col-lg">
                    <label>{{'order.product.product' | translate}} *</label>
                    <apc-form-select formControlName="product" [items]="products" (isOpen)="fetchProducts()" (isChanged)="patchCode($event, data)"
                        [loading]="productsLoading" [isObject]="true" [optionDescription]="['code']" [autogenerated]="data.value.product && data.value.identifier">
                    </apc-form-select>
                </div>
                <div class="form-group col-lg">
                    <label>{{'order.product.code' | translate}}</label>
                    <apc-form-input [class]="'form-control autogenerated'" [disabled]="true" formControlName="code" [type]="'text'">
                    </apc-form-input>
                </div>
                <div class="form-group col-lg">
                    <label>{{'order.product.quantityOrder' | translate}} *</label>
                    <apc-form-input [class]="'form-control'" formControlName="quantity" [type]="'number'">
                    </apc-form-input>
                </div>

            </div>
        </div>
    </form>
</ng-template>